import { api } from "..";

export const getShareObligation = async (token, obligationId) => {
  try {
    const { data } = await api({
      url: `/api/v1/admin/shareObligations/${obligationId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      data,
    };
  } catch (error) {
    return {
      error,
    };
  }
};
